var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloonBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.012,
    height: 125.31,
    viewBox: "0 0 50.012 125.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.572,117.29c-3.159,1.084-3.9,5.37-2.811,8.513s6.459,11.866,6.459,25.522c0,12.666-10.918,23.253-15.53,28.9",
    transform: "translate(-12.639 -55.544)",
    fill: "none",
    stroke: "#2f2e41",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.012,25.006c0,13.809-11.2,35.851-25.006,35.851S0,38.815,0,25.006a25.006,25.006,0,0,1,50.012,0Z",
    transform: "translate(0 0)",
    fill: "#0d71e8",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.742,118.2a4.143,4.143,0,0,0-4.822,0V116h4.822Z",
    transform: "translate(-20.325 -54.933)",
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43,115.41a5.322,5.322,0,0,0,4.827,0",
    transform: "translate(-20.363 -54.653)",
    fill: "none",
    stroke: "#2f2e41",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.514,28.125c2.911,0,5.264-2.832,5.264-6.317S65.42,15.49,62.514,15.49s-5.264,2.832-5.264,6.317S59.6,28.125,62.514,28.125Z",
    transform: "translate(-27.111 -7.335)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonBlue);
export default __webpack_public_path__ + "static/media/balloon_blue.f25c81d47d7ef0000a54b841e58bc163.svg";
export { ForwardRef as ReactComponent };